export function prepareLabel(
    name?: string,
    label?: string,
    required?: boolean,
    bulkMode?: boolean,
): string {
    let newLabel = label ?? name ?? '';
    const endsWithAsterisk = /(:?\*$|\*:$)/g.test(newLabel);
    const endsWithColon = /(:|\*:$)/g.test(newLabel);

    if (!endsWithColon) {
        newLabel = `${newLabel}:`;
    }

    if (
        !endsWithAsterisk &&
        required &&
        newLabel[newLabel.length - 1] !== '*' &&
        !bulkMode
    ) {
        return `${newLabel}*`;
    }

    return newLabel;
}
